import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthPageComponent } from './__/containers/auth-page.component';
import { routesForgotPassword } from './forgot-password/forgot-password.routes';
import { routesLogin } from './login/login.routes';
import { routesRegister } from './register/register.routes';

const routes: Routes = [
  {
    path: 'auth', pathMatch: 'prefix',
    children: [
      {path: 'register', component: AuthPageComponent, children: [...routesRegister]},
      {path: 'login', component: AuthPageComponent, children: [...routesLogin]},
      {path: 'password', component: AuthPageComponent, children: [...routesForgotPassword]},
    ],
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule],
})
export class AuthRoutingModule {
}






// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/auth-routing.module.ts